export class SetInspectionInstanceCustomNameError extends Error {
  constructor(message: string = 'Failed to set inspection instance custom name') {
    super(message);
    this.name = 'SetInspectionInstanceCustomNameError';
  }
}
